import react from "react";
import { useUser } from "./admin/useUser";
import SmallHeaderCard from "@/components/SmallHeaderCard";
import AdminLineItem from "@/components/AdminLineItem";
import typo from "@/styles/Typography.module.css";
import { NavLink } from "react-router-dom";

export default function SurveyManager() {
  const user = useUser();
  console.log("SurveyManager user:", user);

  return (
    <div>
     <AdminLineItem title="Admin Dashboard" user={user}>
          <div className="mb-4">
            <h1 style={{color: "#F16D09", paddingBottom: "2.5rem", marginTop: "3rem"}}>Reports Management</h1>
          </div>
      <div>
         {/* Reports section */}
       <div className="row g-1">
      <div>
          <div style={{ paddingTop: ".5rem", marginTop: "2rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
        REPORTING MANAGEMENT TOOLS
            </p>
          </div>
        </div>
        <div>
          <div>
           <div className={typo.cardWhite_narrow} style={{ paddingTop: "1rem", paddingBottom: ".5rem"}}>
              <NavLink
                to="/admin/reports/reportCreator"
                className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
                style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
              >
                Create embedded reports - create new reports to be embedded in the portal, e.g. on the user dashboard
              </NavLink>
            </div>

            <div className={typo.cardWhite_narrow} style={{ paddingTop: "1rem", paddingBottom: ".5rem", marginBottom: "2rem"}}>
              <NavLink
                to="/admin/reports/reportMonitor"
                className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
                style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
              >
                Manage reports - view and manage reports, release to users, allocate permissions etc **
              </NavLink>
            </div>

            {/* <div className={typo.cardWhite_narrow} style={{ paddingTop: "1rem", paddingBottom: ".5rem", marginBottom: "2rem"}}>
              <NavLink
                to="/admin/monitoring/userLoginActivity"
                className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
                style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
              >
                Monitor user report access - view a heatmap of report access, showing light and heavy times of use.
              </NavLink>
            </div>
             */}
          </div>
        </div>
       </div>
      </div>
      </AdminLineItem>
      </div>
  );
}
